import { OrganizationType } from '@on3/api';
import { OrganizationAutoComplete } from '@on3/ui-lib/components/AutoComplete/OrganizationAutoComplete';
import { Input } from '@on3/ui-lib/components/Input/Input';
import { ProfileDetailsContext } from '@public/components/Modals/Player/Details';
import { useContext } from 'react';

import styles from './DetailsOrganization.module.scss';

export const DetailsOrganization = () => {
  const { values, errors, handleUpdate } = useContext(ProfileDetailsContext);

  return (
    <div className={styles.block}>
      <Input
        error={errors['hsClassYear.value']}
        label="High School Graduation Year"
        name="hsClassYear"
        onChange={(e) =>
          handleUpdate('hsClassYear.value', Number(e.target.value))
        }
        type="numeric"
        value={String(values.hsClassYear.value ?? '')}
      />
      <OrganizationAutoComplete
        error={errors['highSchool.organizationKey']}
        id="highSchool"
        label="High School"
        limit={1}
        name="highSchool"
        onChange={(v) => {
          handleUpdate('highSchool.organizationKey', v[0]?.key);
          handleUpdate('highSchool.organizationName', v[0]?.label);
        }}
        type={OrganizationType.HighSchool}
        value={[
          {
            key: values.highSchool.organizationKey as number,
            label: values.highSchool.organizationName as string,
            value: values.highSchool.organizationKey as number,
          },
        ].filter((v) => v.key)}
      />
    </div>
  );
};
